import { render, staticRenderFns } from "./CustomFieldSimpleExample.vue?vue&type=template&id=3c0d57ef&scoped=true&"
import script from "./CustomFieldSimpleExample.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldSimpleExample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d57ef",
  null
  
)

export default component.exports